exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__background___2R-en{position:fixed;top:0;left:0;width:100%;height:100%;z-index:0}.style__content___lP-gx{z-index:1;position:relative}.style__content___lP-gx input[type=text]{height:46px}@media (min-width:1921px){.style__background___2R-en{background:url(" + require("./new-session-diamond-pattern@2x.png") + ");background-size:cover}}@media (max-width:1920px){.style__background___2R-en{background:url(" + require("./new-session-diamond-pattern.png") + ");background-size:cover}}", ""]);

// exports
exports.locals = {
	"background": "style__background___2R-en",
	"content": "style__content___lP-gx"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/containers/client/style.css
// module id = 723
// module chunks = 0